/**
 * Unauthenticated API paths (no JWT required).
 * Keep in sync with backend public route registrations.
 */
export const PUBLIC_API_PATHS = [
  '/settings-management/public/branding',
  '/platform/themes/public',
  '/carousel-management/public/carousels',
] as const

export function isPublicApiPath(urlPath: string): boolean {
  const normalized = urlPath.split('?')[0] ?? ''
  return PUBLIC_API_PATHS.some(
    (path) =>
      normalized === path ||
      normalized.endsWith(path) ||
      normalized.includes('/carousel-management/public/carousels')
  )
}
